<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-auto" *ngIf="loggedIn != ''">
      <label kupari-label [class]="'col-sm-4'" [text]="loggedIn" ></label>
    </div>
    <div class="col">
    <button type="button" class="btn btn-primary" *ngIf="(type == 'GOOGLE' || type == 'ANY') && loggedIn == ''" (click)="loginWithGoogle()">Login with Google</button>
    <button type="button" class="btn btn-primary" *ngIf="(type == 'MICROSOFT' || type == 'ANY') && loggedIn == ''" (click)="loginWithMicrosoft()">Login with Microsoft</button>
    <button type="button" class="btn btn-secondary" *ngIf="(type == 'GOOGLE' || type == 'MICROSOFT') && loggedIn != ''"(click)="logout()">Logout</button>
    </div>
  </div>
</div>
